import {useParams, useRouteMatch} from 'react-router-dom';
import {UserPlaylistItems} from '../../../../../../../components/user-playlists/user-playlist-items';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {CaregiverPathExtensions} from '../../../../../../../components/caregiver-routes/caregiver-routes';
import {useEffect, useState} from 'react';
import {PlaylistsRepository} from '../../../../../../../repositories/playlists';
import {Playlist} from '../../../../../../../backend/interfaces/playlist';

export default function ProfessionalCaregiverPlaylistItemsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  const {t} = useTranslation();
  const officeContext = useOffice();
  let {id, entityId, playlistId}: {id: string; entityId: string; playlistId: string} = useParams();
  let {url} = useRouteMatch();
  const [playlist, setPlaylist] = useState<Playlist | undefined>();

  useEffect(() => {
    const getPlaylist = async () => {
      try {
        // Get the playlist
        const result =
          await PlaylistsRepository.instance.getPlaylistByIdForEntityAsAffiliatedForEntity(
            entityId,
            playlistId,
            true
          );

        if (result) {
          // Set playlist
          setPlaylist(result);
        } else {
          // Error
          throw new Error('Empty playlist.');
        }
      } catch (error) {
        // Log
        console.debug('🔴 Could not get the playlist.', error);
      }
    };

    // Get the playlist
    getPlaylist();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playlistId]);

  return (
    <UserPlaylistItems
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWrite}
      userId={id}
      entityId={entityId}
      userName={
        officeContext.state.userForm?.user.displayName ||
        officeContext.state.userForm?.user.name ||
        ''
      }
      playlistId={playlistId}
      playlistItemRowBaseLinkUrl={`${url}/items`}
      isLoadingHeader={!playlist}
      headerTitleCrumbs={[
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs.team
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs
              .professionals
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label:
            officeContext.state.userForm?.user.displayName ||
            officeContext.state.userForm?.user.name ||
            '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}/${id}/${CaregiverPathExtensions.Profile}`,
        },
        {
          label: t(translations.screen_paths.senior_playlists),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}/${id}/${CaregiverPathExtensions.Playlists}`,
        },
        {
          label: playlist?.name || '',
          link: url,
        },
      ]}
    />
  );
}
